
export const TimePeriodAggregationType = {
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Quarterly: 'Quarterly',
    Yearly: 'Yearly'
};

export const TimePeriodAggregationTypes = [
    TimePeriodAggregationType.Weekly,
    TimePeriodAggregationType.Monthly,
    TimePeriodAggregationType.Quarterly,
    TimePeriodAggregationType.Yearly
];
